export default __webpack_public_path__ + "static/media/Sage's Straps of the Exalted Spirit.631e4f21.jpg";